import { Lieux } from '@/store/centreVaccination/types';
import { CodeScolaire } from '@/store/codeScolaire/types';
import { CategorieLieuType, VaccinType } from '@/store/folder/types';

export interface StadeVaccination {
	stade: number;
	libelle: string;
}

export const stades: StadeVaccination[] = [
	{
		stade: 1,
		libelle: '1ère vaccination'
	}
];

export interface InfosVaccinForm {
	lieuVaccination: CategorieLieuType;
	centreVaccination: Lieux;
	codePostal: string;
	vaccin: VaccinType;
	lot: string;
	stadeVaccination: StadeVaccination;
	dateInjection: string;
	horaireVaccination: string;
	zoneVaccination: string;
	numFiness: string;
	codeScolaire: string;
}

export interface DetailsVaccinData {
	vaccin: VaccinType;
	lot?: string;
	stadeVaccination: StadeVaccination;
	dateInjection: string;
	horaireVaccination: string;
	zoneVaccination: string;
}

export interface DetailsLocalisationData {
	lieuVaccination: CategorieLieuType;
	centreVaccination: Lieux;
	codePostal: string;
	numFiness: string;
	codeScolaire: string;
}
